import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/app/store';
import { MarketInfo, MarketInfoResponse } from '@cex/shared-modules';
import { widgetBaseApi } from '@/features/widgetBaseApi/widgetBaseApi';

type ApiMarketInfoResponse = {
  marketInfos: MarketInfoResponse;
};

const marketInfoAdapter = createEntityAdapter<MarketInfo>({});
const initialState = marketInfoAdapter.getInitialState();

export const marketInfoApi = widgetBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMarketInfo: builder.query({
      query: () => '/api/market-info',
      providesTags: (result) =>
        result
          ? [...result.ids.map((id) => ({ type: 'MarketInfo' as const, id })), { type: 'MarketInfo', id: 'Info' }]
          : ['MarketInfo'],
      transformResponse: (res: ApiMarketInfoResponse) => {
        return marketInfoAdapter.setAll(initialState, res.marketInfos);
      }
    })
  })
});

// Selectors
// Calling `someEndpoint.select(someArg)` generates a new selector that will return
// the query result object for a query with those parameters.
// To generate a selector for a specific query argument, call `select(theQueryArg)`.
// In this case, the users query has no params, so we don't pass anything to select()
// @ts-ignore
const selectMarketInfoResult = marketInfoApi.endpoints.getMarketInfo.select();

export const selectMarketInfoData = createSelector(selectMarketInfoResult, (apiSlice) => apiSlice.data);

export const { selectAll: selectAllMarketInfo, selectById: selectMarketInfoById } = marketInfoAdapter.getSelectors(
  (state: RootState) => selectMarketInfoData(state) ?? initialState
);

export const { useGetMarketInfoQuery } = marketInfoApi;
